import { render, staticRenderFns } from "./UserDetailsDocuments.vue?vue&type=template&id=5a364083&scoped=true&"
import script from "./UserDetailsDocuments.vue?vue&type=script&lang=js&"
export * from "./UserDetailsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsDocuments.vue?vue&type=style&index=0&id=5a364083&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a364083",
  null
  
)

export default component.exports